export function parseAmount(raw: unknown): number | null {
    if (raw === undefined || raw === null || raw === '') {
        return null
    }
    const normalized = String(raw).replace(',', '.')
    if (!/^[0-9]+(\.[0-9]+)?$/.test(normalized)) {
        return null
    }
    return Number(normalized)
}

export function computeSharesFromAmount(
    amount: number,
    unitPrice: number | null | undefined,
    decimalise: boolean,
    nbDecimale: number,
): number {
    if (!unitPrice || unitPrice <= 0) {
        return 0
    }
    const factor = decimalise && nbDecimale > 0 ? Math.pow(10, nbDecimale) : 1
    return Math.floor((amount / unitPrice) * factor) / factor
}
